/* Mirrors the backend's OFFICIAL_ATTACHMENT_EXTENSIONS (bookings/models.py)
   -- keep the two lists in sync; the model's FileExtensionValidator is the
   real gate, this just gives an admin an immediate error instead of a round
   trip. Size matches client_max_body_size in the nginx site config and
   DATA_UPLOAD_MAX_MEMORY_SIZE in Django settings — a larger file is rejected
   by nginx with a 413 before the request ever reaches the API. */
export const OFFICIAL_ATTACHMENT_ACCEPT = ".pdf,.doc,.docx,.jpg,.jpeg,.png";
export const MAX_ATTACHMENT_SIZE = 10 * 1024 * 1024;
export const ATTACHMENT_TOO_LARGE_MSG = "File must be 10 MB or smaller";

/* Appends a booking payload's scalar fields and its optional nested
   `preferences` list onto a FormData body. DRF's multipart parser needs
   HTML-form bracket notation for nested lists (`field[index]key=value`) --
   a JSON-encoded string is rejected as "This field is required." Shared by
   CreateBookingTab's create-with-attachment submit and the booking
   edit-details re-upload, which both need this same shape whenever a file
   is being sent alongside the rest of the form. */
export function appendBookingPayload(fd, payload) {
  const { preferences, ...scalars } = payload;
  Object.entries(scalars).forEach(([k, v]) => fd.append(k, String(v)));

  (preferences || []).forEach((p, i) => {
    fd.append(`preferences[${i}]guest_house`, String(p.guest_house));
    fd.append(`preferences[${i}]priority`, String(p.priority));
    (p.room_requests || []).forEach((rr, j) => {
      fd.append(`preferences[${i}]room_requests[${j}]room_type`, String(rr.room_type));
      fd.append(`preferences[${i}]room_requests[${j}]count`, String(rr.count));
    });
  });

  return fd;
}
